import React from "react";

function Hash({ hash, hashError, hashStatus }) {
  return (
    <>
      <legend>Результат</legend>

      <label htmlFor="hash">Хеш (ГОСТ Р 34.11-2012 256 бит):</label>

      <br />

      <textarea
        cols="80"
        id="hash"
        placeholder={hashStatus}
        readOnly
        rows="5"
        value={hash}
      />

      <pre>{hashError || null}</pre>
    </>
  );
}

export default Hash;
